import IngredientDetail from "./ingredientDetail";


export default IngredientDetail;